import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const TakePaymentsForm = ({ enabled, t }) => {
    return (
        <div>
            <Field name='merchantId' component={Input} required type='text' label={t('TakePayments_MerchantId')} validate={enabled && validators.required} trimOnBlur />
            <Field name='signatureKey' component={Input} required type='text' label={t('TakePayments_SignatureKey')} validate={enabled && validators.required} trimOnBlur />
            <Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
            <Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
            <Field name='useSandbox' component={Checkbox} label={t('TakePayments_UseSandbox')} help={t('PaymentMethod_UseSandbox_HelpText')} normalize={(v) => !!v} />
        </div>
    );
};


export default TakePaymentsForm;